"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateNewEntityPanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyProvider = require("@adsk/alloy-provider");
var _IssueCreationModal = require("../issue-creation-components/IssueCreationModal");
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// the only thing the following crazy type does is look into the ReferencePickerPlugin type
// to get the props interface for CreateNewEntityPanel.
// "NonNullable" just deals with the fact that CreateNewEntityPanel is optional,
// and "Parameters" gets the parameters of the CreateNewEntityPanel function

const CreateNewEntityPanel = _ref => {
  let {
    onClose,
    onCreateSuccess,
    open,
    fixedTypeId,
    sourceMetadata
  } = _ref;
  const toolId = (0, _alloyProvider.useCurrentToolId)();
  const rpContextType = toolId ? _constants.TOOL_ID_TO_RP_CONTEXT_TYPE[toolId] : null;
  return /*#__PURE__*/_react.default.createElement(_IssueCreationModal.IssueCreationModal, {
    isOpen: open,
    onClose: onClose,
    analyticsData: {
      referencePicker: rpContextType || "unknown"
    },
    onCreate: newItem => {
      onCreateSuccess(newItem);
    },
    fixedTypeId: fixedTypeId,
    locationId: sourceMetadata === null || sourceMetadata === void 0 ? void 0 : sourceMetadata.locationId
  });
};
exports.CreateNewEntityPanel = CreateNewEntityPanel;
//# sourceMappingURL=CreateNewEntityPanel.js.map